import { useContext } from 'react'

import { UserSessionContext } from '../context'

export const useSessionContext = () => {
  const context = useContext(UserSessionContext)

  if (!context) throw new Error('context must be in a context provider')

  return context
}
